export * from 'server/models/ItineraryPointSelf';


// WEBPACK FOOTER //
// ./data/models/ItineraryPointSelf.ts